export enum TicketLayout {
    Badge = 0,
    A4 = 1
}
